import React from 'react';
import { Chip } from '@mui/material';
import { DoNotDisturbOn } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const Away = (props) => {
   const openDrawer = () => {
      props.setStatusDrawerOpen(true);
      props.setSpaceData(props.data);
   };
   if (props.miniChips) {
      return (
         <Chip
            size="small"
            sx={props.styles}
            variant="outlined"
            clickable={props.clickable}
            label={<DoNotDisturbOn color="secondary" />}
            color="secondary"
         />
      );
   } else {
      if (props.clickable) {
         return (
            <Chip
               size="medium"
               sx={{
                  '& .MuiChip-label': {
                     pl: 1,
                  },
               }}
               clickable={props.clickable}
               label={<DoNotDisturbOn sx={{ mt: 0.5 }} />}
               color="secondary"
               deleteIcon={<MoreVertIcon />}
               variant="outlined"
               onDelete={() => openDrawer()}
            />
         );
      } else {
         return (
            <Chip
               size="medium"
               clickable={props.clickable}
               label={<DoNotDisturbOn sx={{ mt: 0.5 }} />}
               color="secondary"
               variant="outlined"
            />
         );
      }
   }
};
export default Away;
